import { BackTop } from "../class/BackTop";

document.querySelectorAll('.button--back-top').forEach(element => { 
    new BackTop(element, {
        type: "slide--bottom"  // slide--bottom, slide--right, zoom, fade
    })
});
